import * as colors from "@remar/shared/dist/colors";

import { DoubleExtendedPalette } from "@remar/shared/dist/models/theme.types";

import defaultColorPalette from "./dark_defaultPalette";

const colorPalette: Partial<DoubleExtendedPalette> = {
	type: "dark",
	...defaultColorPalette,
	primary: {
		text: colors.basic[100],
		contrastText: colors.basic[100],
		dark: colors.red[800],
		light: colors.red[200],
		main: colors.red[600],
		tabs: {
			border: colors.red[500],
			contrastText: colors.red[800],
			main: colors.red[300]
		}
	},
	secondary: {
		text: colors.basic[200],
		contrastText: colors.red[600],
		dark: colors.red[800],
		light: colors.red[200],
		main: colors.red[200],
		tabs: {
			contrastText: colors.red[800],
			dark: colors.red[500],
			main: colors.red[200],
			border: colors.red[600]
		}
	}
};

export default colorPalette;
